import Vue from 'vue'
import { Input } from 'ant-design-vue'
import { savePreviousData } from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment-timezone'

Vue.use(Input)

export default Vue.extend({
  components: { DatePicker },
  template: `
    <div class="a-gcell">
      <a-popover trigger="click" v-model="visible" class="datePickerRenders">
      <div slot="content" style="
        max-width: 250px;
        margin-top: -16px;">
        <a-tabs default-active-key="1">          
          <a-tab-pane key="1" tab="Date">
          <date-picker
          format="YYYY-MM-DD"
          v-model="value"
          @change="changeDate"
          type="date"
          inline
        />
        </a-tab-pane>
          <a-tab-pane key="2" tab="Month" force-render>
            <date-picker
            v-model="value"
            format="YYYY-MM"
            type="month"
            @change="changeDate"
            inline
          />
          </a-tab-pane>
          <a-tab-pane key="3" tab="Year">
            <date-picker
            format="YYYY"
            v-model="value"
            @change="changeDate"
            type="year"
            inline
          />
          </a-tab-pane>
      </a-tabs>
      </div>
      <a-input 
        placeholder="MM/DD/YYYY" 
        size="small" 
        v-model="value" 
        :autoFocus="true" 
        @keydown.tab="validateDate" 
        @keydown.enter="validateDate" 
        @blur="validateDate"
        @focus="savePreviousData(value)"
      >
      <a-icon slot="suffix" type="calendar" />
      </a-input>
    </a-popover>
    </div>
    `,

  data() {
    return {
      visible: true,
      value: null,
      loading: false,
      editorShow: true,
      savePreviousData: savePreviousData,
      keyPressed: false,
      updatedValue: null,
    }
  },
  created() {
    this.value = this.params.value
  },
  methods: {
    changeDate(date, dateString) {
      const settings = JSON.parse(localStorage.getItem('userSettings'))
      this.dateFormat = settings
      this.visible = false
      switch (dateString) {
        case 'year':
          this.value = moment(new Date(date)).format('YYYY')
          this.saveData(this.value)
          break
        case 'month':
          this.value = moment(new Date(date)).format('MM/YYYY')
          this.saveData(this.value)
          break
        case 'date':
          this.value = moment(new Date(date)).format('MM/DD/YYYY')
          this.saveData(this.value)
          break
      }
      this.keyPressed = true
    },
    saveData(date) {
      if (this.params.value !== this.value) {
        switch (this.params.colDef['cellRendererParams'].type) {
          case 'projectDetails':
            this.$root.$emit('updateAssetsDetails', date, this.params.data, this.params.colDef.field, this.params.rowIndex, null)
            break
          default:
            break
        }
      }
    },
    validateDate(event) {
      if (this.keyPressed) {
        event.stopPropagation()
        return false
      } else if (this.updatedValue !== event.target.value) {
        this.updatedValue = event.target.value
        let fomatDate = null
        const dtString = event.target.value.split('/')
        if (dtString.length > 2 && event.target.value) {
          if (dtString[0] > 12) {
            dtString[0] = String(12)
          }
          if (dtString[1] < 10 && dtString[1].length < 2) {
            dtString[1] = '0' + dtString[1]
          }
          fomatDate = [dtString[0], dtString[1], dtString[2]].join('/')
          this.value = moment(new Date(fomatDate)).format('MM/DD/YYYY')
        } else if (dtString.length > 1 && event.target.value) {
          if (dtString[0] > 12) {
            dtString[0] = String(12)
          } else if (dtString[0] < 10 && dtString[0].length < 2) {
            dtString[0] = '0' + dtString[0]
          }
          fomatDate = [dtString[0], '01', dtString[1]].join('/')
          this.value = moment(new Date(fomatDate)).format('MM/YYYY')
        } else if (dtString.length === 1 && event.target.value) {
          fomatDate = ['01', '01', dtString[0]].join('/')
          this.value = moment(new Date(fomatDate)).format('YYYY')
        } else {
          this.value = null
        }
        if (this.value !== 'Invalid date') {
          this.$root.$emit('updateAssetsDetails', this.value, this.params.data, this.params.colDef.field, this.params.rowIndex, null, event.keyCode)
        } else {
          this.value = null
          this.$root.$emit('updateAssetsDetails', 'Invalid date', this.params.data, this.params.colDef.field, this.params.rowIndex, null, event.keyCode)
        }
      }
    },
    getValue() {
      return this.value
    },
  },
})
